import React, { useState } from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import Pagination from '@mui/material/Pagination';
import { NavLink } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { postRequest } from '../../lib/api';
import { AuthContext } from '../../authContext/context';
import CircularProgress from '@mui/material/CircularProgress';
import Swal from 'sweetalert2';


import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import SearchIcon from '@mui/icons-material/Search';
import PhoneIcon from '@mui/icons-material/Phone';
import FormControl from '@mui/material/FormControl';

const Notes = () => {

  return (
    <>
        <div className='page-header'>
        <h1 className='mt-0'>Notes</h1>
        
      </div>
        <div className='page-top-formview mb-3'>
            <Form>
                            <Form.Group className="mb-3" controlId="formCurrentPassword">
                                <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                                    <TextField
                                           id="outlined-multiline-static"
                                           label="Write Note Here"
                                           multiline
                                           rows={4}
                                           // defaultValue="Default Value"
                                         />
                                </FormControl>
                            </Form.Group>

                            <Stack spacing={2} direction="row">
                               <Button variant="outlined" className='red-outline-btn text-capitalize'>
               Cancel
             
            </Button> <Button variant="contained" type="submit" className='red-bg red-button text-capitalize'>Submit</Button>
                            </Stack>
                        </Form>
        </div>

      </>
  );
};

export default Notes;

